if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const value = event.currentTarget.dataset.value;

        this.elements.input.value = value;

        if (typeof orbito !== 'undefined' && form) {
          const inputCountry = form.querySelector('input[name="country_code"]');
          const inputLanguage = form.querySelector('input[name="locale_code"]');
          const returnToInput = form.querySelector("input[name='return_to']");
          const shopDomain =
            typeof orbito.getCountryDomain === 'function'
              ? orbito.getCountryDomain() || window.location.hostname
              : window.location.hostname;

          if (inputCountry && returnToInput) {
            function setParam(name, paramValue, addIfMissing) {
              if (returnToInput.value.match(new RegExp('(\\?|&)' + name + '=[^&]*'))) {
                returnToInput.value = returnToInput.value.replace(
                  new RegExp('(\\?|&)' + name + '=[^&]*'),
                  '$1' + name + '=' + paramValue
                );
              } else if (addIfMissing) {
                returnToInput.value +=
                  (returnToInput.value.includes('?') ? '&' : '?') + name + '=' + paramValue;
              }
            }

            // country: replace or add. oc: only replace if it already exists
            setParam('country', value, true);
            setParam('oc', value, false);

            document.cookie = `mdApp_countryCodeDomain=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
          }

          if (inputLanguage) {
            document.cookie = `mdApp_showRecommendationLang=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
          }
        }

        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
